import { render } from "./availableitem.vue?vue&type=template&id=21f28c62&scoped=true"
import script from "./availableitem.vue?vue&type=script&lang=js"
export * from "./availableitem.vue?vue&type=script&lang=js"

import "./availableitem.vue?vue&type=style&index=0&id=21f28c62&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f28c62"]])

export default __exports__